import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { login, clearError } from '../store/slices/authSlice';
import { DEPARTMENTS } from '../utils/constants';

const LoginPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user, loading, error } = useSelector((state) => state.auth);

  const [credentials, setCredentials] = useState({
    email: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    if (user) {
      // Redirect based on department
      if (user.role === 'admin') {
        navigate('/sales');
      } else {
        const userDepts = user.departments || [user.department];

        // Redirect to first available department dashboard
        if (userDepts.includes(DEPARTMENTS.SALES)) {
          navigate('/sales');
        } else if (userDepts.includes(DEPARTMENTS.HR)) {
          navigate('/hr');
        } else if (userDepts.includes(DEPARTMENTS.STAFFING_SALES)) {
          navigate('/staffing');
        } else {
          // Redirect to default dashboard for employees without specific department access
          navigate('/dashboard');
        }
      }
    }

    return () => {
      dispatch(clearError());
    };
  }, [user, navigate, dispatch]);

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await dispatch(login(credentials));
  };

  return (
    <div className="login-page min-vh-100 d-flex align-items-center justify-content-center px-3 py-4">
      <div className="card login-card shadow-sm">
        <div className="card-body p-4 p-md-5">
          <div className="text-center mb-4">
            <span className="icon-shape icon-lg bg-primary text-white rounded-3 fs-2 fw-semibold d-inline-flex mb-3">
              EM
            </span>
            <h1 className="card-title h5 mb-2">Enterprise Management System</h1>
            <p className="text-muted small mb-0">Sign in to your account</p>
          </div>

          {error && (
            <div className="alert alert-danger py-2 mb-3 small" role="alert">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <input
                id="email"
                type="email"
                name="email"
                className="form-control"
                value={credentials.email}
                onChange={handleChange}
                required
                autoComplete="email"
                autoFocus
                disabled={loading}
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password" className="form-label">
                Password
              </label>
              <div className="input-group">
                <input
                  id="password"
                  type={showPassword ? 'text' : 'password'}
                  name="password"
                  className="form-control"
                  value={credentials.password}
                  onChange={handleChange}
                  required
                  autoComplete="current-password"
                  disabled={loading}
                />
                <button
                  type="button"
                  className="btn btn-outline-secondary"
                  onClick={() => setShowPassword((prev) => !prev)}
                  tabIndex="-1"
                >
                  <i className={`ti ${showPassword ? 'ti-eye-off' : 'ti-eye'}`} />
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="btn btn-primary w-100"
              disabled={loading}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
